import { colors } from 'fitify-ui'
import { Typography } from 'fitify-ui-landing/src/components/Typography/Typography'

import { Button } from '@/components/exercises/Button/Button'

import { StyledFilterPills, StyledFilterRow } from './Filter.Styled'

type FilterItem = {
  label: string
  value: string
}

type FilterProps = {
  label: string
  filters: FilterItem[]
  activeFilter: string
  onFilterChange: (value: string) => void
}

export const Filter = ({
  label,
  filters,
  activeFilter,
  onFilterChange,
}: FilterProps) => {
  return (
    <StyledFilterRow>
      <Typography $color={colors.Gray600} $variant="Special/Label 12 Uppercase">
        {label}
      </Typography>
      <StyledFilterPills>
        {filters.map((filter) => (
          <Button
            key={filter.value}
            isActive={activeFilter === filter.value}
            onClick={() => {
              onFilterChange(filter.value)
            }}
          >
            {filter.label}
          </Button>
        ))}
      </StyledFilterPills>
    </StyledFilterRow>
  )
}
